import React from "react";
import { ResponsiveContainer, LineChart, Line, XAxis, YAxis, Tooltip, BarChart, Bar, CartesianGrid } from "recharts";

const AXIS = { stroke: "#333", tick: { fill: "#525252", fontSize: 10 }, tickLine: false, axisLine: { stroke: "#1A1A1A" } };
const GRID = { stroke: "#111", strokeDasharray: "2 4", vertical: false };

function TooltipCard({ active, payload, label, unit, formatLabel }) {
  if (!active || !payload || !payload.length) return null;
  return (
    <div className="card p-2 text-xs" style={{ background: "#0A0A0A" }}>
      <div className="text-t3">{formatLabel ? formatLabel(label) : label}</div>
      {payload.map((p, i) => (
        <div key={i} className="font-mono tabular" style={{ color: p.color || "var(--lime)" }}>
          {p.value}{unit || ""}
        </div>
      ))}
    </div>
  );
}

export function WeightHistoryChart({ data }) {
  if (!data || data.length < 2) {
    return <div className="text-t3 text-sm">Log your bodyweight a few times to see the line.</div>;
  }
  return (
    <div className="w-full h-40" data-testid="chart-weight">
      <ResponsiveContainer>
        <LineChart data={data} margin={{ top: 8, right: 12, left: -8, bottom: 0 }}>
          <CartesianGrid {...GRID} />
          <XAxis dataKey="date" {...AXIS} tickFormatter={(d) => d.slice(5)} minTickGap={20} />
          <YAxis {...AXIS} domain={["dataMin - 1", "dataMax + 1"]} width={38} />
          <Tooltip content={<TooltipCard unit=" kg" />} cursor={{ stroke: "#333" }} />
          <Line type="monotone" dataKey="weightKg" stroke="var(--lime)" strokeWidth={2} dot={{ r: 2, fill: "var(--lime)", stroke: "none" }} activeDot={{ r: 4 }} isAnimationActive={false} />
        </LineChart>
      </ResponsiveContainer>
    </div>
  );
}

export function VolumeByWeekChart({ data }) {
  if (!data || data.length === 0) {
    return <div className="text-t3 text-sm">Finish a session — volume trends show here.</div>;
  }
  return (
    <div className="w-full h-40" data-testid="chart-volume">
      <ResponsiveContainer>
        <BarChart data={data} margin={{ top: 8, right: 12, left: -8, bottom: 0 }}>
          <CartesianGrid {...GRID} />
          <XAxis dataKey="weekStart" {...AXIS} tickFormatter={(d) => d.slice(5)} minTickGap={20} />
          <YAxis {...AXIS} width={44} tickFormatter={(v) => v >= 1000 ? `${(v/1000).toFixed(1)}t` : v} />
          <Tooltip content={<TooltipCard unit=" kg" formatLabel={(d) => `Week of ${d}`} />} cursor={{ fill: "rgba(193,255,0,0.06)" }} />
          <Bar dataKey="volumeKg" fill="var(--lime)" radius={[4, 4, 0, 0]} />
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
}
